import { React } from "react";
import { useTranslation } from 'react-i18next';

const PropiedadesBuscar = ({ lang, ruta, propiedades }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    {/* ************ */ }

    return (
        <>
            <section className="u-align-center u-clearfix u-container-align-center u-section-1" id="block-13">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <div className="u-expanded-width u-layout-grid u-list u-list-1">
                        <div className="u-repeater u-repeater-1">
                            {
                                propiedades.map((unbarco, indexb) => (
                                    <div className="u-align-center u-container-align-center u-container-style u-list-item u-repeater-item" key={"barco-" + indexb}>
                                        <div className="u-container-layout u-similar-container u-container-layout-1">
                                            <a href={"/" + preidioma + t("embarcaciones") + "-" + unbarco.destino.url_dinamica[lang] + "/" + unbarco.url_dinamica}>
                                                {
                                                    (unbarco.foto_principal && unbarco.foto_principal.length > 0) ?
                                                        <img className="u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="2062" data-image-height="1374" src={ruta + "/propiedades/" + unbarco.id + "/fotos/web/" + unbarco.foto_principal[0].nombre} />
                                                        :
                                                        <img className="u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="2062" data-image-height="1374" src="/images/web/onboard2/00-ONBOARDLOGO-HORIZONTAL-TR_TRANSP-2025.png" />
                                                }
                                            </a>

                                            <i className="fa-solid fa-ruler-triangle"></i> {unbarco['metros_cuadrados']}m | <i className="fa-solid fa-bed"></i> {unbarco['num_habitaciones']} | <i className="fa-solid fa-users"></i> {unbarco.capacidad_maxima}
                                            <h4 className="u-text u-text-1">
                                                <a href={"/" + preidioma + t("embarcaciones") + "-" + unbarco.destino.url_dinamica[lang] + "/" + unbarco.url_dinamica} className="u-active-none u-border-none u-btn u-button-style u-hover-none u-none u-text-palette-1-base u-btn-5">{unbarco.nombre}<br />
                                                </a>
                                            </h4>
                                            <p className="u-align-center u-text u-text-grey-50 u-text-2">{unbarco.nombre_ruta}<br />
                                            </p>
                                            <a href={"/" + preidioma + t("contacto")} className="u-align-center u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-1-base u-radius u-btn-2">{t("Solicitar presupuesto")} </a>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    {
                        propiedades.length == 0 ?
                            <div className="centra">
                                {t("No se han encontrado resultados con los parámetros suministrados. Vuelva a hacer la consulta con otros diferentes.")}
                            </div>
                            :
                            ""
                    }
                </div>
            </section >
            <section className="u-clearfix u-section-2" id="block-11">
                <div className="u-clearfix u-sheet u-sheet-1"></div>
            </section>
        </>
    );
};

export default PropiedadesBuscar;

